const Footer = () => {
    return(
        <div class="p-3 mb-2 bg-black text-white footer">
            <p>Designed and developed by Sindy Montaño © 2025</p>
        </div>
    );
};

export default Footer;